import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Shield, Scale } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      {/* Trust Badges */}
      <div className="border-b border-slate-800">
        <div className="container-app py-6">
          <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-sm text-slate-400">
            <div className="flex items-center gap-2">
              <Shield className="w-5 h-5 text-green-500" />
              <span>SSL Secured</span>
            </div>
            <div className="flex items-center gap-2">
              <Scale className="w-5 h-5 text-amber-500" />
              <span>Bar Council Verified Lawyers</span>
            </div>
            <div className="flex items-center gap-2">
              <Shield className="w-5 h-5 text-blue-500" />
              <span>DPDP Act 2023 Compliant</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="container-app py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand & Company Info */}
          <div className="md:col-span-1">
            <Link to="/" className="text-2xl font-bold" data-testid="footer-logo">
              Legal<span className="text-amber-500">Hub</span>
            </Link>
            <p className="mt-4 text-slate-400 text-sm">
              India's trusted platform for legal consultations. Connect with verified lawyers.
            </p>
            <div className="mt-4 text-xs text-slate-500">
              <p><strong>LegalHub</strong></p>
              <p>Mumbai, Maharashtra, India</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/lawyers" className="text-slate-400 hover:text-white transition-colors">
                  Find Lawyers
                </Link>
              </li>
              <li>
                <Link to="/register/lawyer" className="text-slate-400 hover:text-white transition-colors">
                  Join as Lawyer
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-slate-400 hover:text-white transition-colors">
                  Register as Client
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-slate-400 hover:text-white transition-colors">
                  Login
                </Link>
              </li>
              <li>
                <Link to="/stats" className="text-slate-400 hover:text-white transition-colors">
                  Platform Statistics
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Pages */}
          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-contact">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-terms">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-disclaimer">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2 text-slate-400">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>Mumbai, Maharashtra<br />India</span>
              </div>
              <div className="flex items-start gap-2 text-slate-400">
                <Mail className="w-4 h-4 mt-0.5 shrink-0" />
                <div>
                  <a href="mailto:info@legalhubs.info" className="hover:text-amber-400 transition-colors block">info@legalhubs.info</a>
                  <a href="mailto:deepakrao1983@gmail.com" className="hover:text-amber-400 transition-colors block">deepakrao1983@gmail.com</a>
                </div>
              </div>
              <div className="flex items-center gap-2 text-slate-400 hover:text-amber-400 transition-colors">
                <Phone className="w-4 h-4" />
                <a href="tel:+919076433479">+91 9076433479</a>
              </div>
            </div>
          </div>
        </div>

        {/* Compliance Notice */}
        <div className="mt-10 pt-6 border-t border-slate-800">
          <div className="bg-slate-800/50 rounded-lg p-4 text-xs text-slate-400">
            <p className="mb-2">
              <strong className="text-slate-300">Compliance Notice:</strong> All lawyers listed on LegalHub are independent 
              practitioners enrolled with State Bar Councils under the Bar Council of India. They are required to comply 
              with the Advocates Act, 1961 and Bar Council of India Rules on Professional Standards and Etiquette.
            </p>
            <p>
              LegalHub is a technology platform and does NOT provide legal advice. We are NOT a law firm. 
              Any information on this website is for general informational purposes only and should not be 
              construed as legal advice.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-6 pt-6 border-t border-slate-800 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} LegalHub. All rights reserved.
          </p>
          <div className="flex flex-wrap gap-4 text-xs text-slate-500">
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/disclaimer" className="hover:text-white">Disclaimer</Link>
            <Link to="/contact" className="hover:text-white">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
